import Image from 'next/image'
import galleryVideoLayout from '@/assets/img/gallery-video-layout.jpg'
import { useTranslation } from 'react-i18next'

const Multimedia = ({ pageType, data, setGalleryOpen, setVideoOpen }) => {
    const { t } = useTranslation()
    return (
        <>
            {(pageType !== 'vacancy' && pageType !== 'webinar' && data?.photos?.length) || data?.videos ? (
                <div className='news-details__gallery'>
                    {data?.photos?.length && (
                        <div className='news-details__gallery-content'>
                            <h5 className='news-details__gallery-title'>{t('photoReport')}</h5>
                            <ul
                                className='news-details__gallery-list photo'
                                onClick={() => setGalleryOpen(true)}
                            >
                                {data.photos?.slice(0, 5).map(pic => (
                                    <li className='news-details__gallery-pic'>
                                        <div className='news-details__gallery-layout'>
                                            <svg
                                                width='20'
                                                height='16'
                                                viewBox='0 0 20 16'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'
                                            >
                                                <path
                                                    d='M1 13.1059V3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V13.1059C19 14.2104 18.1046 15.1059 17 15.1059H3C1.89543 15.1059 1 14.2104 1 13.1059Z'
                                                    stroke='#F3F6FE'
                                                    strokeWidth='1.6'
                                                />
                                                <path
                                                    d='M1 15.106L8.20908 7.4339C8.29125 7.34644 8.4314 7.35054 8.50833 7.44264L11.4597 10.9762C11.5468 11.0805 11.7105 11.0694 11.7827 10.9541L13.9214 7.53997C13.9998 7.41487 14.182 7.41487 14.2604 7.53997L19 15.106'
                                                    stroke='#F3F6FE'
                                                    strokeWidth='1.6'
                                                />
                                            </svg>
                                        </div>
                                        <Image
                                            src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${pic}`}
                                            width={100}
                                            height={100}
                                            alt='gallery-pic'
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {data?.videos && (
                        <div className='news-details__gallery-content'>
                            <h5 className='news-details__gallery-title'>{t('videoReport')}</h5>
                            <ul className='news-details__gallery-list video'>
                                <li
                                    onClick={() => setVideoOpen(true)}
                                    className='news-details__gallery-pic'
                                >
                                    <div className='news-details__gallery-layout'>
                                        <svg
                                            width='20'
                                            height='20'
                                            viewBox='0 0 20 20'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                d='M4.8 16.4755V3.60533C4.8 3.06572 5.3848 2.72903 5.85146 2.99996L17.2916 9.64178C17.7637 9.91588 17.7543 10.6009 17.2748 10.8619L5.83471 17.0903C5.36826 17.3442 4.8 17.0066 4.8 16.4755Z'
                                                stroke='#C1CCE2'
                                                strokeWidth='1.6'
                                                strokeLinejoin='bevel'
                                            />
                                        </svg>
                                    </div>
                                    <Image
                                        src={galleryVideoLayout}
                                        width={100}
                                        height={100}
                                        alt='gallery-pic'
                                    />
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            ) : null}
        </>
    )
}

export default Multimedia
